import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="w-full bg-gray-100 px-6 py-20 sm:px-10" data-id="element-47" data-mp="1iy1dfw9agt66">
      <div className="mx-auto max-w-3xl" data-id="element-48" data-mp="1nvku12tgli1a">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-49" data-mp="2bkcc31dc4k0c">Preguntas frecuentes</h2>

        <div className="mt-12 space-y-4" data-id="element-50" data-mp="2fmh2lr8hl0ir">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.pregunta} className="rounded-xl border border-gray-200 bg-white" data-id="element-51" data-mp="21sgcflvlolu0" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? -1 : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-52" data-mp="26rj7qels3dos">
                  <span className="text-base font-bold text-mint-dark" data-id="element-53" data-mp="1vqaskcsofazw">{item.pregunta}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-mint-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-54" data-mp="1rph33ezl5o4w" />
                </button>
                <AnimatePresence initial={false} data-id="element-55" data-mp="2fcfmolj05c71">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="2adm5oj4ib324">
                      <p className="px-6 pb-6 text-sm leading-loose text-gray-600" data-id="element-57" data-mp="p1cdb5bbmqwy">{item.respuesta}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}